module.exports = __webpack_public_path__ + "static/media/allocate-light.7d134838.svg";